<template>
  <div class="container">
    <v-expansion-panels>
      <v-expansion-panel isActive="true">
        <v-expansion-panel-header>
            Φίλτρα αναζήτησης
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" sm="6">
              <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="documentIssueDateStartFilter"
                          label="Ημερομηνία (Από)"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          clearable>
                      </v-text-field>
                  </template>
                  <v-date-picker
                      v-model="documentIssueDateStartFilter"
                      @input="menu1 = false">
                  </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6">
                <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="documentIssueDateStopFilter"
                            label="Ημερομηνία (Έως)"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="documentIssueDateStopFilter"
                        @input="menu2 = false">
                    </v-date-picker>
                </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
                <!-- <v-autocomplete 
                    v-bind:items="accounts" 
                    v-model="selectedAccount"
                    return-object
                    
                    item-text="name" 
                    label="Πελάτης"
                    clearable>
                </v-autocomplete> -->
                <v-text-field 
                    v-model="customerNameFilterValue"
                    type="text"
                    label="Επωνυμία"
                    clearable>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field 
                    v-model="tradeNameFilterValue"
                    type="text"
                    label="Διακ. Τίτλος"
                    clearable>
                </v-text-field>
            </v-col>
            
        </v-row>

        <v-row>
            <v-col cols="12" sm="6">
              <v-select 
                    v-bind:items="invoiceStatusValues"
                    item-text="name"
                    item-value="id"

                    v-model="invoiceStatus"

                    type="text"
                    label="Κατάσταση τιμολόγησης"
                    clearable>
                </v-select>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field 
                    v-model="distributorFilterValue"
                    type="text"
                    label="Διανομέας"
                    clearable>
                </v-text-field>
                
            </v-col>
            
        </v-row>

                    <v-row class="my-3" cols="12" align="center" justify="center">
            <v-btn 
                color="success" 
                rounded
                elevation="2"
                class="mx-2 px-5 font-weight-bold white--text"
                @click="getData" 
                :loading="getDataButtonDisabled"
            >
                <v-icon left size="20">mdi-magnify</v-icon>
                <span>ΑΝΑΖΗΤΗΣΗ</span>
            </v-btn>

            <v-btn 
                color="orange darken-2" 
                dark
                rounded
                elevation="2"
                class="mx-2 px-5 font-weight-bold white--text"
                @click="clearFilters" 
            >
                <v-icon left size="20">mdi-broom</v-icon>
                <span>ΚΑΘΑΡΙΣΜΑ</span>
            </v-btn>
          </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      loading-text="Φόρτωση παραγγελιών πελατών..."
      no-data-text="Δεν υπάρχουν δεδομένα"
      :sort-by="['date']"
      :sort-desc="true"
      class="elevation-1 my-2"
      disable-filtering>
      
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Αποτελέσματα</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          
          <v-spacer></v-spacer>
          <table-export-menu
            title="Παραγγελίες ανά πελάτη"
            :headers="headers"
            :items="items"
            :visible="showExport"
            button-class="mb-2"
          />

        </v-toolbar>
      </template>
      
      <template v-slot:[`item.date`]="{ item }">
        {{ formatDate(item.date) }}
      </template>


      <template v-slot:[`item.debit`]="{ item }">
        {{ formatMoney(item.debit) }}
      </template>

      <template v-slot:[`item.credit`]="{ item }">
        {{ formatMoney(item.credit) }}
      </template>

      <template v-slot:[`item.oldBalance`]="{ item }">
        {{ formatMoney(item.oldBalance) }}
      </template>

      <template v-slot:[`item.newBalance`]="{ item }">
        {{ formatMoney(item.newBalance) }}
      </template>

      <template slot="body.append" v-if="showExport">
        <tr>
            <th>Σύνολα</th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th class="text-right">{{totalsSum('quantity', 2)}}</th>
            
        </tr>
      </template>

    </v-data-table>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    data: () => ({
      loading: true,
      invoiceStatusValues: [
        { id: -1, name: 'Ανεξάρτητα'},
        { id: 0, name: 'Εκκρεμείς'},
        { id: 1, name: 'Τιμολογημένες'},
      ],

      allerrors : {
        
      },

      dialog: false,

      headers: [
        {
          text: 'Πελάτης',
          align: 'start',
          value: 'name',
        },
        {
          text: 'Διακριτικός Τίτλος',
          align: 'start',
          value: 'trade_name',
        },
        {
          text: 'Διανομέας',
          align: 'start',
          value: 'distributor',
        },
        { 
          text: 'Κωδικός', 
          align: 'left',
          value: 'code' 
        },
        { 
          text: 'Είδος', 
          align: 'left',
          value: 'description' 
        },
        { 
          text: 'Ποσότητα', 
          align: 'right',
          value: 'quantity',
          exportTransformer: (cell) => cell.replace('.', ',')  
        },
      ],

      items: [],


      documentTypes: [],
      accounts: [],

      selectedAccount: {},

      documentTypeFilter: null,

      documentIssueDateStartFilter: null,
      documentIssueDateStopFilter: null,

      tradeNameFilterValue: null,
      customerNameFilterValue: null,
      distributorFilterValue: null,
      representativeFilterValue: null,

      getDataButtonDisabled: false,
      getExcelButtonDisabled: false,

      menu2: null,
      menu1: null,

      invoiceStatus: null,


    }),

    watch: {

    },

    created () {
      this.initialize()
    },

    computed: {
      showExport() {
        return this.items?.length > 0
      }
    },

    methods: {

      totalsSum(fieldName, fixDecimals) {
        const sum = this.items?.map(x => parseFloat(x[fieldName])).reduce((a, b) => a + b, 0)

        if (fixDecimals > 0)
          return sum.toFixed(2)

        return parseInt(sum)
      },

      excelPlease() {
        if (this.items?.length > 0 == false) {
          console.log('No items!')
          return
        }

        const transform = (line, columnDefinitions) => {
          let out = []

          columnDefinitions.forEach(columnDefinition => {

            const columnValue = line[columnDefinition.propertyName]

            if (columnDefinition.exportTransformer)
              out.push(columnDefinition.exportTransformer(columnValue))
            else
              out.push(columnValue)
          });

          return out;
        }

        const exportableColumns = this.headers.filter(x => (x.exportable ?? true) == true)
        const columnDefinitions = exportableColumns.map(x => ({ propertyName: x.value, exportTransformer: x.exportTransformer }))

        const requestBody = {
          table_headers: exportableColumns.map(x => x.text),
          table_entries: this.items.map(line => transform(line, columnDefinitions))
        }

        this.axiosDownload('/api/test', requestBody, 'αναφορά.xlsx')
      },

      axiosDownload(url, requestBody, filename) {
        this.getExcelButtonDisabled = true;

        axios({
            url: url, 
            data: requestBody,
            method: 'POST',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.getExcelButtonDisabled = false
        // link.remove();
        // url.remove();

        }).catch(err => { console.log(err); this.getExcelButtonDisabled = false})
      },

      formatDate(value) {
        return moment(value).format("DD/MM/YYYY")
      },

      formatMoney(amount) {
        if (amount == null)
          amount = 0.0

        return amount.toFixed(2)
      },


      initialize () {
        this.$store.dispatch('currentUser/getCurrentUser')
        
        const initialDaysBeforeFilterValue = 30

        const today = new Date();

        let filterStart = new Date()
        filterStart.setDate(today.getDate() - initialDaysBeforeFilterValue);

        this.documentIssueDateStartFilter = this.$localDateString(filterStart)
        this.documentIssueDateStopFilter = this.$localDateString(today)

        

        // this.getData();
        this.getFilterValues()
      },

      getFilterValues() {
        // this.accounts = axios.get('/api/accounts')
        //     .then(response => {
        //         this.accounts = response.data
        //     }).catch(error => console.log(error))
      },
      
      getRequestParams() {
        let out = {
          dianomeas: null,
          diakritikos: null,
          eponimia: null,
          invoice_status: -1
        }


        if (this.documentIssueDateStartFilter != null)
          out.issue_date_start = this.documentIssueDateStartFilter

        if (this.documentIssueDateStopFilter != null)
          out.issue_date_stop = this.documentIssueDateStopFilter

        if (this.selectedAccount != null)
            out.customer_id = this.selectedAccount.id

        if (this.tradeNameFilterValue?.length > 0)
          out.diakritikos = this.tradeNameFilterValue

        if (this.customerNameFilterValue?.length > 0)
          out.eponimia = this.customerNameFilterValue


        if (this.distributorFilterValue?.length > 0)
          out.dianomeas = this.distributorFilterValue

        if (this.invoiceStatus != null)
          out.invoice_status = this.invoiceStatus
        
        return out
      },

      getData() {
        this.loading = true;
        this.allerrors = {}

        const params = this.getRequestParams()

        if (params.issue_date_start == null || params.issue_date_stop == null)
          return


        this.getDataButtonDisabled = true;
        axios.post(
            '/api/reports/order-sums-per-customer', 
            {
                params: params
            }
        )
        .then(response => this.items = response.data)
        .finally(() => {
          this.getDataButtonDisabled = false;
          this.loading = false;
        })
        .catch(error => { 
          if (error.response.data)
              this.allerrors = error.response.data.errors
         })
        
      },


      clearFilters() {
        this.documentIssueDateStartFilter = null
        this.documentIssueDateStopFilter = null
      }
    }
  }
</script>

<style scoped>
.v-data-table-header th {
  white-space: nowrap;
}
</style>